///**
// * Created by Viktor on 2016.05.24..
// * And M.Tomi :)
// */
$(function(){
    // mutargy_search.init(book_id);
    $('#showtext').click(function(e){
        e.preventDefault();
        $('div#page-text .text').css('max-height','100%');
        $(this).hide();
        $('#hidetext').show();
    });

    $('#hidetext').click(function(e){
        e.preventDefault();
        $('div#page-text .text').removeAttr('style');
        $(this).hide();
        $('#showtext').show();
    });

    $('div.pager #next-page').click(function(e){
        turnBook.flipbook.turn("next");
    });

    $('div.pager #prev-page').click(function(e){
        turnBook.flipbook.turn("previous");
    });

    // initDirectory();

});

function initDirectory(){
    $('.list-open').click(function(e){
        var list = $('#'+$(this).data('id'));
        if($(list).hasClass('open')){
            $(list).removeClass('open');
            $(this).html($(this).data('open'));
        }
        else{
            $(list).addClass('open');
            $(this).html($(this).data('close'));
        }
    });

    if(calcHeight($('#left .italic')) <= 25){
        $('.list-open[data-id=left]').hide();
    }
    else{
        $('.list-open[data-id=left]').show();
    }
    if(calcHeight($('#right .italic')) <= 25){
        $('.list-open[data-id=right]').hide();
    }
    else{
        $('.list-open[data-id=right]').show();
    }
}

/**
 * @param elements
 * @returns {number}
 */
function calcHeight(elements){
    var height = 0;
    $.each(elements,function(){
        height += $(this).height();
    });
    return height;
}


var turnBook = {
    flipbook: null,
    maxPage: null,
    loadedPage: [0],
    turner: null,
    start_page: null,
    blank_pages: 0,

    loadBook: function () {
        console.log(turnBook.blank_pages);
        this.flipbook = $('#book');
        turnBook.setFlipBook(this.flipbook);
        turnBook.start_page = parseInt($("#turn #page").text());

        turnBook.flipbook.hide();

        turnBook.preLoadPages(function(){
            turnBook.flipbook.show();
            if(turnBook.start_page > 0){
                turnBook.jumpTo(turnBook.start_page + turnBook.blank_pages);
            }
        });

        // $('form#turn').submit(function(e){
        //     e.preventDefault();
        //     var jumpto = $(this).find('input[name=page]').val();
        //     turnBook.jumpTo(parseInt(jumpto) + turnBook.blank_pages);
        // });
    },
    /**
     * Betölti az oldalakat a háttérben, az összeset
     * @param callback
     */
    preLoadPages : function(callback) {
        $.ajax({
            type: "POST",
            url: "ajaxRequest/book/getAllPage",
            data: 'book='+book_id,
            dataType: "json",
            beforeSend: function() {
                var img = $('<img>').attr('src', '/components/kieselbach/front/assets/images/ajax-loader.gif')
                    .css({
                        position: 'absolute',
                        left: '50%',
                        top: '22%',
                    })
                    .addClass('ajaxLoader')
                    .appendTo($('.book-wrapper'));
            },
            success: function (response) {
                turnBook.buildBookPages(response.data, function() {
                    $('.ajaxLoader').remove();
                    callback();
                });
            }
        });
    },
    /**
     * Felépíti az oldalakat, beállítja a szélességet, inicializálja a TURN JS-t
     * @param data
     * @param callback
     */
    buildBookPages : function(data, callback) {
        console.log(data);
        $("#book").html(data.html);
        $("#book").imagesLoaded()
            .always(function(){
                console.log('betöltött minden oldal.');

                var dinWidth;
                var image_url = $('#pagenum-2').css('background-image'),
                    image;
                if(image_url) {
                    image_url = image_url.match(/^url\("?(.+?)"?\)$/);

                    if (image_url[1]) {
                        image_url = image_url[1];
                        image = new Image();
                        //alert(image.width + 'x' + image.height);

                        $(image).on('load',function () {
                            //alert(image.width + 'x' + image.height);
                            dinWidth = image.width * 2;

                            turnBook.initTurnJS(dinWidth);


                            if (typeof callback == "function") {
                                callback();
                            }
                        });
                        image.src = image_url;
                    }
                }
            });
    },
    /**
     * Turn JS inicializálás
     * Zoom Init
     * @param dinWidth
     */
    initTurnJS : function(dinWidth) {
        console.log(dinWidth);
        this.flipbook.turn({
            width: dinWidth,
            height: 550,
            elevation: 50,
            display: 'double',
            acceleration: !turnBook.isChrome(),
            autoCenter: true,
            gradients: true,
            duration: 1000,
            pages: turnBook.maxPage,
            when: {
                turning: function (event, page, view){
                    var nextright = view[0] - turnBook.blank_pages;
                    turnBook.loadDirectory(nextright, book);
                    $('#page').text(nextright);
                }
            }
        });

        this._initZoom();
    },
    /**
     * Zoom init
     * @private
     */
    _initZoom : function() {
        $('.book-viewport').zoom({
            flipbook: $('#book'),

            max: function() {
                return turnBook.largeBookWidth()/$('#book').width();
            },
            when: {
                swipeLeft: function() {
                    $(this).zoom('flipbook').turn('next');
                },
                swipeRight: function() {

                    $(this).zoom('flipbook').turn('previous');

                },
                resize: function(event, scale, page, pageElement) {
                    if(page-1 >= 0){
                        page = page-1;
                    }
                    if (scale==1)
                        turnBook.loadSmallPage(page, pageElement);
                    else
                        turnBook.loadLargePage(page, pageElement);
                },
                zoomIn: function () {

                    $('#slider-bar').hide();
                    $('.made').hide();
                    $('#book').removeClass('animated').addClass('zoom-in');
                    $('.zoom-icon').removeClass('zoom-icon-in').addClass('zoom-icon-out');

                },
                zoomOut: function () {
                    $('#slider-bar').fadeIn();
                    $('.exit-message').hide();
                    $('.made').fadeIn();
                    $('.zoom-icon').removeClass('zoom-icon-out').addClass('zoom-icon-in');

                    setTimeout(function(){
                        $('#book').addClass('animated').removeClass('zoom-in');
                        turnBook.resizeViewport();
                    }, 0);
                }
            }
        });

        // Zoom event
        //if ($.isTouch)
        $('.book-viewport').bind('zoom.doubleTap', turnBook.zoomTo);
        //else
        //    $('.book-viewport').bind('zoom.tap', turnBook.zoomTo);

        $('.zoom-icon').bind('mouseover', function() {
            if ($(this).hasClass('zoom-icon-in'))
                $(this).addClass('zoom-icon-in-hover');

            if ($(this).hasClass('zoom-icon-out'))
                $(this).addClass('zoom-icon-out-hover');

        }).bind('mouseout', function() {

            if ($(this).hasClass('zoom-icon-in'))
                $(this).removeClass('zoom-icon-in-hover');

            if ($(this).hasClass('zoom-icon-out'))
                $(this).removeClass('zoom-icon-out-hover');

        }).bind('click', function() {

            if ($(this).hasClass('zoom-icon-in'))
                $('.book-viewport').zoom('zoomIn');
            else if ($(this).hasClass('zoom-icon-out'))
                $('.book-viewport').zoom('zoomOut');

        });
    },
    jumpTo: function(page){
        this.flipbook.turn("page", parseInt(page) + 1);
    },
    setFlipBook: function(flipbook){
        this.flipbook = flipbook;
    },
    addPage: function (page, book) {
        // Create an element for this page
        var element = $('<div class="loaderImg"></div>').html('<img src="'+$('#dataholder').data('gif')+'">');
        // Add the page
        book.turn('addPage', element, page);
        var last = parseInt($('#dataholder').data('lastpage'));
        // Get the data for this page
        $.ajax({
            url: "ajaxRequest/book/getPage",
            method: 'POST',
            dataType: 'json',
            data: {
                page: page,
                book: book_id,
                last: last,
            },

            success: function (resp) {
                turnBook.loadedPage.push(page);
                book.turn('addPage', resp.data.img, page);
                $('section.directory-of-art').html(resp.data.html);
                initDirectory();
            }
        });
    },
    loadDirectory: function(page, book){
        var last = parseInt($('#dataholder').data('lastpage'));
        $.ajax({
            url: "ajaxRequest/book/getPage",
            method: 'POST',
            dataType: 'json',
            data: {
                page: parseInt(page) - turnBook.blank_pages,
                book: book_id,
                last: last,
            },
            success: function (resp) {
                $('.directory-of-art').html(resp.data.html);
                // initDirectory();
            }
        });
    },
    isChrome: function () {
        return navigator.userAgent.indexOf('Chrome') != -1;
    },
    largeBookWidth: function() {
        return 2214;
    },
    loadLargePage: function(page, pageElement) {

        var img = $('<img />');

        img.on('load',function () {
            var prevImg = pageElement.find('img');
            $(this).css({width: '100%', height: '100%'});
            $(this).appendTo(pageElement);
            prevImg.remove();
        });
        // Loadnew page
        $.ajax({
            url: "ajaxRequest/book/getLargePage",
            method: 'POST',
            dataType: 'json',
            data: {
                page: page,
                book: book_id,
            },

            success: function (resp) {
                img.attr('src', resp.data.src);
            }
        });

    },
    // Load small page
    loadSmallPage: function(page, pageElement) {

        var img = pageElement.find('img');

        img.css({width: '100%', height: '100%'});

        img.unbind('load');
        // Loadnew page
        $.ajax({
            url: "ajaxRequest/book/getSmallPage",
            method: 'POST',
            dataType: 'json',
            data: {
                page: page,
                book: book_id,
            },

            success: function (resp) {
                img.attr('src', resp.data.src);
            }
        });
    },
    zoomTo: function(event) {
        setTimeout(function () {
            if ($('.book-viewport').data().regionClicked) {
                $('.book-viewport').data().regionClicked = false;
            } else {
                $('#book-container #next').toggle();
                $('#book-container #prev').toggle();
                if ($('.book-viewport').zoom('value') == 1) {
                    $('.book-viewport').zoom('zoomIn', event);
                } else {
                    $('.book-viewport').zoom('zoomOut');
                }
            }
        }, 1);
    },
    resizeViewport: function() {
        var width = $(window).width(),
            height = $(window).height(),
            options = $('#book').turn('options');

        $('#book').removeClass('animated');

        $('.book-viewport').css({
            width: 'auto',
            height: 'auto',
        }).
        zoom('resize');

        if ($('#book').turn('zoom')==1) {
            var bound = turnBook.calculateBound({
                width: options.width,
                height: options.height,
                boundWidth: Math.min(options.width, width),
                boundHeight: Math.min(options.height, height)
            });

            if (bound.width%2!==0)
                bound.width-=1;
        }
        var bookOffset = $('#book').offset(),
            boundH = height - bookOffset.top - $('#book').height(),
            marginTop = (boundH - $('.thumbnails > div').height()) / 2;


        if (bookOffset.top<$('.made').height())
            $('.made').hide();
        else
            $('.made').show();

        $('#book').addClass('animated');

    },

    calculateBound: function(d) {
        var bound = {width: d.width, height: d.height};

        if (bound.width > d.boundWidth || bound.height > d.boundHeight) {

            var rel = bound.width / bound.height;

            if (d.boundWidth / rel > d.boundHeight && d.boundHeight * rel <= d.boundWidth) {

                bound.width = Math.round(d.boundHeight * rel);
                bound.height = d.boundHeight;

            } else {

                bound.width = d.boundWidth;
                bound.height = Math.round(d.boundWidth / rel);

            }
        }

        return bound;
    },
};

// var mutargy_search = {
//     url: null,
//     order: null,
//     text: null,
//     book: null,
//
//     init: function(book){
//         this.book = book;
//         this.url = "ajaxRequest/book/mutargySearch";
//
//         $('input[name=text]').keyup(function(){
//                 mutargy_search.text = $(this).val();
//                 if(mutargy_search.text == ""){
//                     mutargy_search.search();
//                 }
//             }
//         );
//
//         $('select.search').change(function(){
//             mutargy_search[$(this).attr('name')] = $(this).find('option:selected').val();
//             mutargy_search.search();
//         });
//
//         $('#searchSubmit').click(function(){
//             mutargy_search.text = $('input[name=text]').val();
//             mutargy_search.search();
//         });
//     },
//
//     search: function(){
//         $.ajax({
//             url: mutargy_search.url,
//             method: 'post',
//             dataType: 'json',
//             data: {
//                 order:mutargy_search.order,
//                 text: mutargy_search.text,
//                 book: mutargy_search.book
//             },
//             success: function(resp){
//                 mutargy_search.loadCreation(resp.data.html);
//             }
//         })
//     },
//
//     loadCreation: function(html){
//         $('div#creation').html(html);
//         PagerInit();
//     },
// };